export default __webpack_public_path__ + "static/media/gal-7.1605f19e.jpeg";